import * as React from "react";
import styled from "@emotion/styled";
import { H1, SiteContainer, Text } from "atoms";

import {
  useNotifications,
  useMarkNotificationsAsRead,
} from "../api/useNotifications";
import { NotificationContent } from "./NotificationContent";

function AllNotifications() {
  const { data, error } = useNotifications();
  const { mutate } = useMarkNotificationsAsRead();

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      const unread = data
        ?.filter((d) => !d.readAt)
        .map((d) => d.notificationId);
      if (unread) mutate(unread);
    }, 1000 * 2);
    return () => clearTimeout(timeout);
  }, [data, mutate]);

  if (data) {
    return (
      <SiteContainer width="sm">
        <main>
          <H1>Notifications</H1>

          {data.length > 0 ? (
            <NotificationList>
              {data.map((n) => (
                <li key={n.notificationId}>
                  <NotificationContent notification={n} />
                </li>
              ))}
            </NotificationList>
          ) : (
            <Text>You have no notifications</Text>
          )}
        </main>
      </SiteContainer>
    );
  }

  if (error) {
    return (
      <SiteContainer width="md">
        <main>
          <Text>Error: {error.message}</Text>
        </main>
      </SiteContainer>
    );
  }

  return (
    <SiteContainer width="md">
      <main>
        <Text>loading...</Text>
      </main>
    </SiteContainer>
  );
}

const NotificationList = styled.ul(({ theme }) => ({
  listStyleType: "none",
  padding: 0,
  margin: "1em 0",
  lineHeight: 1.3,
  li: {
    borderBottom: `1px solid ${theme.colors.gray10}`,
    borderTop: `1px solid ${theme.colors.gray10}`,
    padding: "1.15rem 0",
  },
  "li+li": {
    borderTop: "0",
  },
  "&>li::before": {
    content: `"\\200B"`,
    position: "absolute",
  },
}));

export { AllNotifications };
